import React,{useEffect,useState} from 'react';
import bgHero from "../Assets/images/sectiontwo.png"
import sectionTwohero from "../Assets/images/sectionTwohero.png"


const SectionTwo = () => {
    const [windowWidth, setWindowWidth] = useState(0);



    let resizeWindow = () => {
        setWindowWidth(window.screen.width);
    };

    useEffect(() => {
        resizeWindow();
        window.addEventListener("resize", resizeWindow);
        return () => window.removeEventListener("resize", resizeWindow);
    }, []);

    return(
        <div
            style={{
                backgroundImage: `url(${bgHero})`,
                backgroundSize: windowWidth < 500 ? '45%' : '28%',  // Ensures the image covers the entire div
                backgroundPosition: '0% 90%', // Centers the image
                backgroundRepeat: 'no-repeat', // Prevents tiling

            }}
            className="w-full flex ">
            <div className='flex flex-col   justify-center lg:mx-auto lg:w-maxWidth w-full pt-24 pb-24  lg:pt-24 gap-10 lg:gap-0'>
                <div className="w-full   flex items-center  justify-center ">
                    <img className="w-2/4  md:w-2/6 lg:w-2/6 " src={sectionTwohero} alt={sectionTwohero} />
                </div>
                <div className="w-full lg:p-0  p-4 justify-center flex flex-col gap-5 ">
                    <h2 className="font-roboto text-2xl lg:text-4xl text-center font-light text-primary "><b className="font-bold">Freelance</b> with confidence, get paid on your terms</h2>
                    <p className=" font-roboto text-secondary text-center text-lg">Use the App to create and present digital invoices, or share payment links instantly with clients and customers anywhere in the world.   Let your customers make payments through a seamless checkout experience on PayPro’s marketplace platform.</p>

                </div>

            </div>
        </div>
    );
}

export  default SectionTwo